<template>
  <b-modal
    centered
    id="modal-export-pdf-harvest"
    hide-footer
    header-class="no-border"
    body-class="no-border"
    modal-class="modalStyle"
    no-close-on-backdrop
  >
    <b-container fluid>
      <b-row class="justify-content-center mb-3">
        <b-col cols="auto">
          <h3 class="title-export-pdf-harvest">Opções de exportação</h3>
        </b-col>
      </b-row>

      <b-row class="justify-content-center mb-3">
        <b-col cols="auto">
          <b-form-input type="date" v-model="selectedDate"></b-form-input>
        </b-col>
      </b-row>

      <b-row class="justify-content-center mt-3 mb-4">
        <b-col cols="8">
          <div class="radio-container">
            <label for="day">
              <input
                type="radio"
                id="day"
                name="radio"
                @click="selectedOption = `day`"
              />
              <div class="custom-radio">
                <span></span>
              </div>
              <span>Dia</span>
            </label>
          </div>

          <div class="radio-container">
            <label for="month">
              <input
                type="radio"
                id="month"
                name="radio"
                @click="selectedOption = `month`"
              />
              <div class="custom-radio">
                <span></span>
              </div>
              <span>Mês</span>
            </label>
          </div>

          <div class="radio-container">
            <label for="year">
              <input
                type="radio"
                id="year"
                name="radio"
                @click="selectedOption = `year`"
              />
              <div class="custom-radio">
                <span></span>
              </div>
              <span>Ano</span>
            </label>
          </div>
        </b-col>
      </b-row>

      <b-row class="justify-content-center">
        <b-col cols="auto">
          <button class="btn-modal-export-pdf-harvest" @click="exportPdf">
            EXPORTAR
          </button>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import showError from '../../utils/showError';

export default {
  data() {
    return {
      selectedOption: null,
      selectedDate: null,
    };
  },
  methods: {
    exportPdf() {
      if (this.selectedOption && this.selectedDate) {
        // Emita um evento com os valores selecionados
        this.$emit('export-pdf', {
          selectedOption: this.selectedOption,
          selectedDate: this.selectedDate,
        });
      } else {
        showError('Selecione uma opção');
      }
    },
    getCurrentDate() {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Mês começa do 0 (janeiro é 0)
      const day = String(currentDate.getDate()).padStart(2, '0');
      this.selectedDate = `${year}-${month}-${day}`;
    },
  },
  created() {
    this.getCurrentDate();
  },
};
</script>

<style lang="scss" scoped>
::v-deep .no-border {
  border: none;
}

::v-deep .modalStyle > .modal-dialog > .modal-content {
  background-color: #c1c1c1;
  font-family: 'Inter', sans-serif;
  font-style: normal;
}

::v-deep button.close {
  color: #2c2c2c;
  outline: none;
}

.title-export-pdf-harvest {
  font-weight: 900;
  line-height: 22px;
  color: #d85a4a;
}

.box-date-export-pdf-harvest {
  font-weight: 900;
  font-size: 17px;
  line-height: 117%;
  color: #545353;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 145px;
  height: 27px;
  border: 1px solid #d85a4a;
  border-radius: 8px;
}

input[type='radio'] {
  display: none;
}

.radio-container label {
  display: flex;
  align-items: center;
  column-gap: 20px;
}

.custom-radio {
  border: 1px solid #000;
  width: 15px;
  height: 15px;
  display: grid;
  place-content: center;
  border-radius: 50%;
}

.custom-radio,
span {
  transition: 0.5s ease;
  color: #000;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
}

.custom-radio span {
  content: '';
  width: 15px;
  height: 15px;
  background: transparent;
  border-radius: 50%;
}

input[type='radio']:checked + .custom-radio {
  border-color: #d85a4a;
}

input[type='radio']:checked + .custom-radio span {
  background: #d85a4a;
}

.btn-modal-export-pdf-harvest {
  min-width: fit-content;
  width: 196px;
  height: 28px;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0.35em;
  font-weight: 700;
  border-radius: 13px;
  border: none;
  background-color: #d85a4a;
  color: #fff;
}

.btn-modal-export-pdf-harvest:focus {
  outline: none;
}
</style>
